import { gql } from '@apollo/client';

export const SINGLE_NEWS_QUERY = gql`
  query GetSingleNews($input: GetSingleNewsInput!) {
    getSingleNews(input: $input) {
      id
      title
      image
      imageCategory
      ingress
      slug
      body
      published
      category
      externalUrl
    }
  }
`;
